module.exports = __webpack_public_path__ + "static/media/country.ba92839f.png";